import React, { Component } from 'react'
import $ from 'jquery'
import * as Common from '../CommonControlls/CommonJs'
import MainLayout from '../CommonControlls/MainLayout'
import Topmenu from '../CommonControlls/Topmenubar'
import { connect } from 'react-redux'
import Table from '../CommonControlls/TableRendrer'
import { Link } from 'react-router-dom'
import {
  SelectCompleteDistrictsList,
  SelectAllProvince,
  SelectTehsilsList,
} from '../OfflineDb/IndexDbTranscSP'
import AlertModal from '../CommonControlls/AlertModal'
import { SyncConfig } from '../OfflineDb/ConfigDataSync'
import DropDown from '../CommonControlls/DropdownRendrer'
import jsPDF from 'jspdf'

const mapStateToProps = (store) => {
  return store
}

const mapDispatchToProps = (dispatch) => {
  return {
    ShowAlert: (Settings) => {
      dispatch({ type: 'UpdateAlert', payload: Settings })
    },
    ShowLoader: (Isloading) => {
      dispatch({ type: 'UpdateLoader', payload: Isloading })
    },
  }
}

class Tehsil_List extends Component {
  constructor(props) {
    super(props)
    this.state = {
      // Table
      data: [],
      page: 1,
      sizePerPage: 15,
      TotalRecord: 0,
      loading: false,
      exportLoading: false,

      SrList: [],
      FilteredSrs: [],
      SrId: [],

      permissions: [],

      sortField: 'id',
      idsortOrder: 'desc',
      provinceNamesortOrder: '',
      districtNamesortOrder: '',
      namesortOrder: '',

      FilteredData: [],

      alertModalData: {
        title: '',
        message: '',
        First_Callback: () => {},
        Second_Callback: () => {},
        type: 1,
      },

      ProvinceLoader: false,
      Provincelist: [],
      ProvinceId: 0,

      DistrictLoader: false,
      Districtlist: [],
      FilteredDistrictlist: [],
      DistrictId: 0,
    }
  }

  HandleAutoSuggestValChange = (fieldId, value) => {
    this.setState({ [fieldId]: value }, () => {
      if (fieldId == 'ProvinceId') {
        var TempArr = this.state.Districtlist
        var filteredArr = TempArr.filter(function (obj) {
          return obj.provinceId == value
        })
        const TempSr = this.state.SrList
        const filtered = TempSr.filter((el) => {
          return el.provinceid === value
        })

        this.setState({
          FilteredDistrictlist: filteredArr,
          FilteredSrs: filtered,
        })
      }
    })
  }

  render() {
    const CellMenu = (cell, row) => {
      return (
        <div>
          {this.state.permissions.includes('tehsil-update') && (
            <Link to={'/Tehsil_Edit/' + row.id}>
              <button
                data-toggle="tooltip"
                title="Edit"
                class="btn TableRow_btn"
              >
                <i
                  class="fa fa-pencil-square-o text-primary"
                  aria-hidden="true"
                ></i>
              </button>
            </Link>
          )}
          {this.state.permissions.includes('tehsil-delete') && (
            <button
              onClick={() => this.onDelete(row.id)}
              data-toggle="tooltip"
              title="Delete"
              class="btn TableRow_btn"
            >
              <i class="fa fa-trash-o text-danger" aria-hidden="true"></i>
            </button>
          )}
        </div>
      )
    }

    const columns = [
      {
        dataField: 'provinceName',
        text: 'Province Name',
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { minWidth: 150 }
        },
      },
      {
        dataField: 'provinceId',
        text: 'Province Id',
        hidden: true,
        export: true,
        
      },

      {
        dataField: 'short_name',
        text: 'SR. Name',
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { minWidth: 120 }
        },
      },
      {
        dataField: 'districtName',
        text: 'District Name',
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { minWidth: 150 }
        },
      },
      {
        dataField: 'districtId',
        text: 'District Id',
        hidden: true,
        export: true,
        
      },

      {
        dataField: 'name',
        text: 'Tehsil Name',
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { minWidth: 150 }
        },
      },
      {
        dataField: 'id',
        text: 'Tehsil Id',
        hidden: true,
        export: true,
       
      },

      {
        dataField: '',
        text: 'Actions',
        headerStyle: (colum, colIndex) => {
          return { minWidth: 120 }
        },
        formatter: (cell, row) => {
          return CellMenu(cell, row)
        },
        csvExport: false,
      },
    ]

    return (
      <div>
        <AlertModal {...this.state.alertModalData} />
        <MainLayout />
        <div id="right-panel" class="right-panel">
          <Topmenu
            PageTitle="Tehsil"
            isShowAddBtn={this.state.permissions.includes('tehsil-add')}
            AddBtnLabel="Add Tehsil"
            AddBtnLink="/Tehsil_Add"
          />
          <div class="content">
            {/* <div class="PageHeader_Container">
                            <h2 class="Pageheading">Tehsil</h2>
                            <div class="PageMenu_Container"><Link to="Tehsil_Add"><button type="submit" id="Form_SaveBtn" class="btn btn_style2">Add District</button></Link></div>
                        </div> */}

            <div class="card">
              <div class="card-body">
                <div class="Table_Search row">
                  <div class="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label for="">Province</label>
                    <DropDown
                      multi={false}
                      dropdownRenderer={false}
                      create={false}
                      onChange={this.HandleAutoSuggestValChange}
                      Type="ProvinceId"
                      options={this.state.Provincelist}
                      val={this.state.ProvinceId}
                      addPlaceholder=""
                      disabled={false}
                      loading={this.state.ProvinceLoader}
                      searchBy="name"
                      labelField="name"
                      valueField="id"
                      contentRenderer={false}
                      placeholder="Select"
                    />
                  </div>

                  <div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="">Sub Recipient</label>
                    <DropDown
                      multi={true}
                      dropdownRenderer={true}
                      create={false}
                      onChange={this.HandleAutoSuggestValChange}
                      Type="SrId"
                      options={this.state.FilteredSrs}
                      val={this.state.SrId}
                      addPlaceholder=""
                      disabled={false}
                      loading={false}
                      searchBy="name"
                      labelField="name"
                      valueField="id"
                      contentRenderer={true}
                      placeholder="Select"
                    />
                  </div>

                  <div class="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label for="">District</label>
                    <DropDown
                      multi={false}
                      dropdownRenderer={false}
                      create={false}
                      onChange={this.HandleAutoSuggestValChange}
                      Type="DistrictId"
                      options={this.state.FilteredDistrictlist}
                      val={this.state.DistrictId}
                      addPlaceholder=""
                      disabled={false}
                      loading={this.state.DistrictLoader}
                      searchBy="name"
                      labelField="name"
                      valueField="id"
                      contentRenderer={false}
                      placeholder="Select"
                    />
                  </div>

                  <div class="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label for="">Tehsil Name</label>
                    <input
                      autocomplete="off"
                      onChange={this.handleInputChange}
                      type="text"
                      class="form-control Search_InputField"
                      id="SearchName"
                      placeholder="Enter Tehsil name"
                    />
                  </div>

                  <div class="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <button
                      style={{ position: 'relative' }}
                      onClick={() => {
                        this.FilterTable()
                      }}
                      id="FormSearchBtn"
                      class="btn SearchTable_Btn"
                    >
                      Search
                    </button>
                  </div>
                </div>

                {/* <div class="TableTop_Buttons">
                        <span onClick={() => { $(".react-bs-table-csv-btn").click()}} class="TableExport_button"><i class="fa fa-download" aria-hidden="true"></i> Export</span>
                    </div> */}

                <Table
                  keyField="id"
                  data={this.state.FilteredData}
                  page={this.state.page}
                  sizePerPage={this.state.sizePerPage}
                  totalSize={this.state.TotalRecord}
                  onTableChange={this.handleTableChange}
                  changeSizePerPage={(size) => {
                    setTimeout(() => {
                      this.setState({
                        exportLoading: true,
                      })
                      this.ExportData(size)
                    }, 100)
                  }}
                  exportAllowed={this.state.permissions.includes(
                    'tehsil-export',
                  )}
                  isPagination={true}
                  exportPdf={this.ExportPdf}
                  columns={columns}
                  pdfExportLoading={this.state.exportLoadingPdf}
                  loading={this.state.loading}
                  RefreshTable={this.PopulateTable}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  handleInputChange = (event) => {
    const { value } = event.target

    const tempData = this.state.data
    const filtered = tempData.filter((item) => {
      return item.name.toLowerCase().includes(value.toLowerCase())
    })
    this.setState({
      FilteredData: filtered,
    })
  }

  FilterTable = () => {
    const tempTehsils = this.state.data
    const tempSrs = this.state.SrId.map((el) => el.id)

    const filtered = tempTehsils.filter(
      (item) =>
        item.provinceId === this.state.ProvinceId &&
        item.districtId === this.state.DistrictId &&
        tempSrs.includes(item.subRecipientId),
    )
    this.setState({
      FilteredData: filtered,
    })
  }

  componentWillMount() {
    if (this.props.UserAuthentication.AuthToken === '') {
      this.props.history.push('/Login')
    }
  }

  componentDidMount() {
    Common.AddClassToMenueLink(
      'MenuLink_Tehsil',
      true,
      'MenuParentLink_Geography',
    )
    // Common.AddClassToMenueLink("MenuLink_Tehsil")
    this.GetPageConfigData(() => {
      this.PopulateTable()
    })

    $('.Search_InputField').on('keypress', (e) => {
      if (e.which === 13) {
        this.PopulateTable()
      }
    })

    this.SelectSubReciepents()

    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'Get',
      false,
      Common.APILinks.SelectAll_RolesPermissions,
      {
        pageSize: 15,
        pageNumber: 1,
      },
      (resp) => {
        const modifiedPermissions = resp.data
          .filter(
            (p) => p.permissioN_GROUP === 'Geography' && p.permissioN_ALLOWED,
          )
          .map((d) => d.permissioN_NAME)
        this.setState({ permissions: modifiedPermissions })
      },
    )
  }

  ExportPdf = () => {
    const doc = new jsPDF()

    $('#FormSearchBtn').prop('disabled', true)
    this.setState({ exportLoadingPdf: true })
    var srIdString =
      this.state.SrId.length === 0
        ? ''
        : ',' + Common.convertToCommaString(this.state.SrId, 'id') + ','
    const Parameters = {
      provinceId: this.state.ProvinceId,
      name: $('#SearchName').val(),
      districtId: this.state.DistrictId,
      pageSize: this.state.TotalRecord,
      pageNumber: this.state.page,
      subrecipientId: srIdString,
    }
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'GET',
      false,
      Common.APILinks.SelectAll_Tehsil,
      Parameters,
      (resp) => {
        $('#FormSearchBtn').prop('disabled', false)
        let { data } = resp
        if (data.length > 0) {
          //Map
          var ProcessedProvince = Common.ProcessDataInArray(
            this.state.Provincelist,
            'id',
          )
          var ProcessedDistrict = Common.ProcessDataInArray(
            this.state.Districtlist,
            'id',
          )
          for (var i in data) {
            data[i].provinceName =
              data[i].provinceId == null
                ? ''
                : ProcessedProvince[data[i].provinceId]?.name
            data[i].districtName =
              data[i].districtId == null
                ? ''
                : ProcessedDistrict[data[i].districtId]?.name
          }

          doc.autoTable({
            theme: 'grid',
            body: [...resp.data],
            columns: [
              { header: 'id', dataKey: 'id' },
              { header: 'Name', dataKey: 'name' },
              { header: 'Province', dataKey: 'provinceName' },
              { header: 'District', dataKey: 'districtName' },
              { header: 'SR Name', dataKey: 'short_name' },
            ],
          })
        }

        doc.save('tehsil.pdf')

        this.setState({ exportLoadingPdf: false })
      },
      (error) => {
        $('#FormSearchBtn').prop('disabled', false)
        this.setState({ loading: false })
        this.props.ShowAlert({ Type: 0, Msg: error })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }
  ExportData = () => {
    $('#FormSearchBtn').prop('disabled', true)
    this.setState({ loading: true })
    var srIdString =
      this.state.SrId.length === 0
        ? ''
        : ',' + Common.convertToCommaString(this.state.SrId, 'id') + ','
    const Parameters = {
      provinceId: this.state.ProvinceId,
      name: $('#SearchName').val(),
      districtId: this.state.DistrictId,
      pageSize: this.state.TotalRecord,
      pageNumber: this.state.page,
      subrecipientId: srIdString,
    }
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'GET',
      false,
      Common.APILinks.SelectAll_Tehsil,
      Parameters,
      (resp) => {
        $('#FormSearchBtn').prop('disabled', false)
        let { data } = resp
        if (data.length > 0) {
          //Map
          var ProcessedProvince = Common.ProcessDataInArray(
            this.state.Provincelist,
            'id',
          )
          var ProcessedDistrict = Common.ProcessDataInArray(
            this.state.Districtlist,
            'id',
          )
          for (var i in data) {
            data[i].provinceName =
              data[i].provinceId == null
                ? ''
                : ProcessedProvince[data[i].provinceId]?.name
            data[i].districtName =
              data[i].districtId == null
                ? ''
                : ProcessedDistrict[data[i].districtId]?.name
          }
        }

        this.setState({
          data: data,
          FilteredData: data,
          exportLoading: false,
        })
        $('.react-bs-table-csv-btn').click()
        this.PopulateTable()
      },
      (error) => {
        $('#FormSearchBtn').prop('disabled', false)
        this.setState({ loading: false })
        this.props.ShowAlert({ Type: 0, Msg: error })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }
  GetPageConfigData = (CallBack) => {
    this.props.ShowLoader({ Isloading: true })
    var d1 = $.Deferred()
    var d2 = $.Deferred()
    this.SelectProvinces(() => {
      d1.resolve()
    })
    this.SelectDistricts(() => {
      d2.resolve()
    })
    $.when(d1, d2).done(() => {
      this.props.ShowLoader({ Isloading: false })
      CallBack()
    })
  }
  SelectProvinces = (Callback) => {
    this.setState({ ProvinceLoader: true })
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'GET',
      false,
      Common.APILinks.SelectAll_Province,
      {},
      (data) => {
        this.setState({
          ProvinceLoader: false,
          Provincelist: data.data,
        })
        Callback()
      },
      (error) => {
        this.setState({ ProvinceLoader: false })
        this.props.ShowAlert({ Type: 0, Msg: error })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
        Callback()
      },
    )
  }
  SelectDistricts = (Callback) => {
    this.setState({ DistrictLoader: true })
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'GET',
      false,
      Common.APILinks.SelectAll_District,
      {},
      (data) => {
        this.setState({
          DistrictLoader: false,
          Districtlist: data.data,
        })
        Callback()
      },
      (error) => {
        this.setState({ DistrictLoader: false })
        this.props.ShowAlert({ Type: 0, Msg: error })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
        Callback()
      },
    )
  }
  handleTableChange = (
    type,
    { page, sizePerPage, filters, sortField, sortOrder, cellEdit },
  ) => {
    if (type === 'sort') {
      let tempFieldorderLabel = sortField + 'sortOrder'
      let tempFieldorder =
        this.state[tempFieldorderLabel] === ''
          ? sortOrder
          : this.state[tempFieldorderLabel] === 'asc'
          ? 'desc'
          : 'asc'
      this.setState(
        {
          sortField,
          [tempFieldorderLabel]: tempFieldorder,
        },
        () => {
          this.PopulateTable()
        },
      )
      return
      // let result = this.state.data
      // // Handle column sort
      // if (sortOrder === 'asc') {
      //     result = result.sort((a, b) => {
      //     if (a[sortField] > b[sortField]) {
      //         return 1;
      //     } else if (b[sortField] > a[sortField]) {
      //         return -1;
      //     }
      //     return 0;
      //     });
      // } else {
      //     result = result.sort((a, b) => {
      //     if (a[sortField] > b[sortField]) {
      //         return -1;
      //     } else if (b[sortField] > a[sortField]) {
      //         return 1;
      //     }
      //     return 0;
      //     });
      // }
      // return
    }
    this.setState(
      {
        page,
        sizePerPage,
      },
      () => {
        this.PopulateTable()
      },
    )
  }
  PopulateTable = () => {
    $('#FormSearchBtn').prop('disabled', true)
    this.setState({ loading: true })
    var srIdString =
      this.state.SrId.length === 0
        ? ''
        : ',' + Common.convertToCommaString(this.state.SrId, 'id') + ','
    const Parameters = {
      provinceId: this.state.ProvinceId,
      name: $('#SearchName').val(),
      districtId: this.state.DistrictId,
      pageSize: this.state.sizePerPage,
      pageNumber: this.state.page,
      subrecipientId: srIdString,
    }
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'GET',
      false,
      Common.APILinks.SelectAll_Tehsil,
      Parameters,
      (data) => {
        $('#FormSearchBtn').prop('disabled', false)
        if (data.data.length > 0) {
          //Map
          var ProcessedProvince = Common.ProcessDataInArray(
            this.state.Provincelist,
            'id',
          )
          var ProcessedDistrict = Common.ProcessDataInArray(
            this.state.Districtlist,
            'id',
          )
          for (var i in data.data) {
            data.data[i].provinceName =
              data.data[i].provinceId == null
                ? ''
                : ProcessedProvince[data.data[i].provinceId]?.name
            data.data[i].districtName =
              data.data[i].districtId == null
                ? ''
                : ProcessedDistrict[data.data[i].districtId]?.name
          }

          // Sort
          if (this.state[this.state.sortField + 'sortOrder'] === 'asc') {
            data.data = data.data.sort((a, b) => {
              if (a[this.state.sortField] > b[this.state.sortField]) {
                return 1
              } else if (b[this.state.sortField] > a[this.state.sortField]) {
                return -1
              }
              return 0
            })
          } else {
            data.data = data.data.sort((a, b) => {
              if (a[this.state.sortField] > b[this.state.sortField]) {
                return -1
              } else if (b[this.state.sortField] > a[this.state.sortField]) {
                return 1
              }
              return 0
            })
          }
        }

        // Paginate
        var paginatedData = Common.paginate(
          data.data,
          this.state.sizePerPage,
          this.state.page,
        )
        this.setState({
          data: paginatedData,
          FilteredData: data.data,
          TotalRecord: data.totalRecord,
          loading: false,
        })
      },
      (error) => {
        $('#FormSearchBtn').prop('disabled', false)
        this.setState({ loading: false })
        this.props.ShowAlert({ Type: 0, Msg: error })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }
  SelectSubReciepents = () => {
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'GET',
      false,
      Common.APILinks.SelectALl_SubRecipient,
      {},
      (resp) => {
        if (resp.status) {
          this.setState({
            SrList: resp.data.map((d) => ({
              id: d.id,
              name: d.short_name,
              ...d,
            })),
          })
        }
      },
    )
  }
  onDelete = (id) => {
    this.setState(
      {
        alertModalData: {
          title: 'Delete Tehsil',
          message: 'Are you sure you want to delete this record.',
          First_Callback: () => {
            $('#Generic-modal-CloseBtn').click()
            this.DeleteRecord(id)
          },
          Second_Callback: () => {
            $('#Generic-modal-CloseBtn').click()
          },
          type: 1,
        },
      },
      () => {
        $('#Show_ArletModal').click()
      },
    )
  }
  DeleteRecord = (id) => {
    this.props.ShowLoader({ Isloading: true })
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'Get',
      false,
      Common.APILinks.Delete_Tehsil,
      { id: id },
      (Result) => {
        if (Result.status) {
          SyncConfig(
            () => {
              this.PopulateTable()
              this.props.ShowLoader({ Isloading: false })
              this.props.ShowAlert({ Type: 1, Msg: 'Deleted Successfully.' })
              setTimeout(function () {
                $('#Alertmsgbtn').click()
              }, 50)
            },
            () => {
              this.props.ShowLoader({ Isloading: false })
              this.props.ShowAlert({
                Type: 0,
                Msg: 'Error in sync, please reload the page',
              })
              setTimeout(function () {
                $('#Alertmsgbtn').click()
              }, 50)
            },
          )
        } else {
          this.props.ShowLoader({ Isloading: false })
          this.props.ShowAlert({ Type: 0, Msg: Result.message })
          setTimeout(function () {
            $('#Alertmsgbtn').click()
          }, 50)
        }
      },
      (error) => {
        this.props.ShowLoader({ Isloading: false })
        this.props.ShowAlert({
          Type: 0,
          Msg: 'Something went wronge, please try again.',
        })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Tehsil_List)
